import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Router, ActivatedRoute } from '@angular/router';
import { environment } from '../../../../environments/environment';
import { pathsSaldo } from 'environments/paths-saldo';
import { UrlSegmentsHelper } from '@app/core/helpers/url-segments.helper';

@Injectable()
export class UserInterceptor implements HttpInterceptor {
    private headers!: HttpRequest<any>;
    public constructor(
        public router: Router,
        public activatedRoute: ActivatedRoute,
    ) {}

    public intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        const pathSegments: Array<string> = UrlSegmentsHelper.extractPathSegments(this.router.url);
        const userRouteIndex: number = UrlSegmentsHelper.hasLangPrefix(this.router.url) ? 1 : 0;
        const isUserPublicRoute: boolean = pathSegments[userRouteIndex] === 'u';

        if (
            isUserPublicRoute &&
            request.url.includes('/u/') &&
            request.url.includes(environment.API_URL + pathsSaldo.API_PATH)
        ) {
            this.headers = request.clone({
                setHeaders: {
                    'user-id': UrlSegmentsHelper.getSegmentByIndex(this.router.url, 2),
                    'user-key': UrlSegmentsHelper.getSegmentByIndex(this.router.url, 3),
                },
            });

            return next.handle(this.headers);
        }

        return next.handle(request);
    }
}
